const form = document.getElementById('activateForm');
const modal = document.getElementById('activationModal');
const confirmBtn = document.getElementById('confirmActivation');
const cancelBtn = document.getElementById('cancelActivation');
const tradeCustomerDiv = document.querySelector('div[data-trade-customer="true"]');
const termsContainer = document.querySelector('#activationModal .terms-container');
const openContainerBtn = document.querySelector('#activationModal .terms-container .open-container');
let isSubmitting = false;

document.cookie = `isTradeUser=true;max-age=3600;path=/account/activate`;

if (localStorage.getItem('termsAccepted') === 'true' || !localStorage.getItem('tradeCustomer')) {
  if (form) {
    //form.style.display = 'none';
    //form.style.visibility = 'hidden';
  } else {
    modal.style.display = 'none';
    modal.style.visibility = 'hidden';
  }
} else {
  if (form) {
    //form.style.display = 'block';
    //form.style.visibility = 'visible';
  } else {
    modal.style.display = 'block';
    modal.style.visibility = 'visible';
  }
}

if (form) {
  form.addEventListener('submit', function (e) {
    if (!isSubmitting) {
      e.preventDefault();
      modal.style.display = 'block';
    }
  });
}

if(openContainerBtn) {
  openContainerBtn.addEventListener('click', function () {
    if(!termsContainer.classList.contains('open')) {
      termsContainer.classList.add('open');
      openContainerBtn.querySelector('span').innerHTML = 'Close Terms';
    } else {
      termsContainer.classList.remove('open');
      openContainerBtn.querySelector('span').innerHTML = 'Open Terms';
    }
  });
}

if (confirmBtn) {
  confirmBtn.addEventListener('click', function () {
    isSubmitting = true;
    localStorage.setItem('termsAccepted', 'true');
    modal.style.display = 'none';
    form.submit();
  });
}

if (cancelBtn) {
  cancelBtn.addEventListener('click', function () {
    modal.style.display = 'none';
  });
}